/* ============================================================================
   MERGED PDP — full-page cascade (mock only)
   Mounts the shipped Plant Source Block, then re-themes the WHOLE page to the
   chosen plant source on the component's `plantsource:change` event: page accent
   colors, the bottle stage + CDT/CBS/BDT tag, every category label/acronym, the
   buy-box tagline, the story profile eyebrow/title + body, the related-product
   grid, and the "About our <category>" slide-up (rendered with the real
   le-about-content classes). Every About trigger opens that category's slide-up.
   ========================================================================== */
(function () {
  "use strict";
  var DATA = window.LE_PRODUCT;
  var CUR = DATA.currencySymbol || "$";

  function esc(s){ return String(s==null?"":s).replace(/[&<>"]/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c];}); }
  function firstSentences(t,n){ var m=String(t||"").match(/[^.!?]+[.!?]+/g)||[t]; var o=m.slice(0,n).join(" ").trim(); if(m.length>n) o=o.replace(/[.!?]+\s*$/,"")+"..."; return o; }

  /* display order: CDT, then Canna-Botanical, then Botanical */
  var ORDER=["cdt","cbs","bdt"];
  DATA.sources.sort(function(a,b){ return ORDER.indexOf(a.key)-ORDER.indexOf(b.key); });
  function money(cents){ var n=cents/100; return CUR+(n%1===0?n.toLocaleString("en-US"):n.toLocaleString("en-US",{minimumFractionDigits:2,maximumFractionDigits:2})); }
  function src(key){ return DATA.sources.find(function(s){return s.key===key;}) || DATA.sources[0]; }
  var mpdp = document.getElementById("mpdp");

  var AROMA_COLOR = { Earthy:"#D08040", Citrus:"#DAA423", Herbal:"#60B050", Fruity:"#DAA423", Sweet:"#B26FB0", Skunky:"#60B050", Gassy:"#F06020", Floral:"#B26FB0" };

  /* ---------- re-theme the whole page ---------- */
  function applySource(s){
    mpdp.style.setProperty("--cat-color", s.accent);
    mpdp.style.setProperty("--cat-deep", s.deep);
    mpdp.style.setProperty("--cat-tint", s.tint);

    document.querySelectorAll("[data-cat-name]").forEach(function(el){ el.textContent = s.catName; });
    document.querySelectorAll("[data-cat-abbr]").forEach(function(el){ el.textContent = s.acr; });

    // cat-tag colouring (uses the theme's own alpha treatment)
    document.querySelectorAll("[data-cat-tag]").forEach(function(el){
      el.style.background = "color-mix(in srgb," + s.accent + " 16%,#fff)";
      el.style.color = s.deep;
    });

    setText("[data-cat-role='tagline']", s.productDesc); /* full text; CSS clamps to 3 lines */
    setText("[data-cat-role='story-body']", s.productDesc);
    setProfile(s);
    var dc=document.querySelector("[data-docs-cat]");
    if(dc) dc.innerHTML = '<img src="'+esc(s.icon)+'" alt=""><span>'+esc(s.name)+'</span>';
    if(s.bottle){ document.querySelectorAll("[data-bottle-img]").forEach(function(im){ im.src=s.bottle; }); }
    setRelatedAll(s);
    renderRelated(s);
    renderDose(s);
    if (aboutOpen) renderAbout(s);
  }
  function setText(sel, txt){ var el=document.querySelector(sel); if(el) el.textContent=txt; }
  function setProfile(s){
    var lbl=document.querySelector("[data-cat-role='profile-eyebrow']");
    var ttl=document.querySelector("[data-cat-role='profile-title']");
    if(lbl) lbl.innerHTML = esc(s.profileLabel).replace("™",'<span class="le-tm">™</span>');
    if(ttl) ttl.textContent = s.profileTitle;
  }
  function setRelatedAll(s){
    var el=document.querySelector("[data-cat-role='related-all-label']");
    if(el) el.textContent = "All " + s.catName;
  }

  /* ---------- related product grid (per source) ---------- */
  function renderRelated(s){
    var grid=document.querySelector("[data-related-grid]");
    if(!grid) return;
    var bottle = s.bottle || "assets/product-bottle.png";
    grid.innerHTML = s.related.map(function(p){
      var ac = AROMA_COLOR[p.aroma] || "#125D67";
      return '<div class="le-rel-item"><a class="le-pdp-rcard" href="#">' +
        '<div class="le-pdp-rcard__bottle"><img src="' + bottle + '" alt=""></div>' +
        '<div class="le-pdp-rcard__content">' +
          '<div class="le-pdp-rcard__eyebrow">The All-Natural Choice<sup style="font-size:9px;">™</sup></div>' +
          '<div class="le-pdp-rcard__name">' + esc(p.title) + '</div>' +
          '<div class="le-pdp-rcard__divider"></div>' +
          '<div class="le-pdp-rcard__cat-label" style="color:' + s.accent + ';">' + esc(s.catName) + '</div>' +
          '<div class="le-pdp-rcard__marks"><span class="le-pdp-rcard__aroma" style="background:' + ac + ';color:#fff;">' + esc(p.aroma).toUpperCase() + '</span></div>' +
          '<div class="le-pdp-rcard__price-note">as low as</div>' +
          '<div class="le-pdp-rcard__price">' + money(p.price) + '</div>' +
        '</div>' +
        '<button type="button" class="le-pdp-rcard__atc" aria-label="Quick add ' + esc(p.title) + '"><div class="le-pdp-rcard__hex">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
        '</div></button>' +
      '</a></div>';
    }).join("");
  }

  /* ---------- usage dosing bars (8-seg, matches live) ---------- */
  function doseSegs(fill, total){
    var out="", filled=Math.floor(fill), half=(fill-filled)>=0.5;
    for(var i=1;i<=total;i++){
      if(i<=filled) out+='<div class="le-pdp-dose-seg le-pdp-dose-seg--filled"></div>';
      else if(i===filled+1 && half) out+='<div class="le-pdp-dose-seg le-pdp-dose-seg--half"></div>';
      else out+='<div class="le-pdp-dose-seg le-pdp-dose-seg--empty"></div>';
    }
    return out;
  }
  var DOSE_ICON = {
    Vape:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M18 4l2 2-9 9-3 1 1-3z"/><path d="M3 21c3-3 6-3 9-6"/></svg>',
    Tinctures:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 3h6v4l-1 2v9a2 2 0 0 1-2 2h0a2 2 0 0 1-2-2V9L9 7z"/></svg>',
    Topical:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M10 2h4v3l1 3v13H9V8l1-3z"/><path d="M9 12h6"/></svg>',
    Gummy:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3c4 5 6 8 6 11a6 6 0 0 1-12 0c0-3 2-6 6-11z"/></svg>'
  };
  function renderDose(s){
    var grid=document.querySelector("[data-dose-grid]");
    if(!grid) return;
    grid.innerHTML = s.aboutPage.dose.map(function(d){
      return '<div class="le-pdp-dose-card"><div class="le-pdp-dose-top"><div class="le-pdp-dose-left">' +
        '<div class="le-pdp-dose-icon">' + (DOSE_ICON[d.format]||DOSE_ICON.Topical) + '</div>' +
        '<div><div class="le-pdp-dose-sublabel">Format</div><div class="le-pdp-dose-format">' + esc(d.format) + '</div></div></div>' +
        '<div class="le-pdp-dose-pct">' + esc(d.pct) + '</div></div>' +
        '<div class="le-pdp-dose-bar">' + doseSegs(d.fill, 8) + '</div>' +
        '<div class="le-pdp-dose-note">ml terps per ml oil</div></div>';
    }).join("");
  }

  /* ---------- About slide-up body (real le-about-content markup) ---------- */
  function aboutDoseSegs(fill){
    var out="", filled=Math.floor(fill), half=(fill-filled)>=0.5;
    for(var i=1;i<=10;i++){
      if(i<=filled) out+='<span class="lab-col-dose-seg is-filled"></span>';
      else if(i===filled+1 && half) out+='<span class="lab-col-dose-seg is-half"></span>';
      else out+='<span class="lab-col-dose-seg"></span>';
    }
    return out;
  }
  function buildAboutBody(s){
    var ap=s.aboutPage, h="";
    if(ap.takeaways && ap.takeaways.length){
      h+='<section class="lab-col-about-block"><div class="lab-col-about-takeaways">' +
         '<div class="lab-col-about-takeaways__label">Quick Overview</div>' +
         '<div class="lab-col-about-takeaways__body"><ul>' +
         ap.takeaways.map(function(t){ return '<li><strong>'+esc(t.lead)+'</strong> '+esc(t.rest)+'</li>'; }).join("") +
         '</ul></div></div></section>';
    }
    h+='<section class="lab-col-about-block"><div class="lab-col-about-label">Ideal for</div>' +
       '<div class="lab-col-about-pills">' + ap.idealFor.map(function(u){return '<span class="lab-col-about-pill">'+esc(u)+'</span>';}).join("") + '</div></section>';

    h+='<section class="lab-col-about-block"><div class="lab-col-about-label">Suggested starting concentrations</div>' +
       '<div class="lab-col-dose-grid">' + ap.dose.map(function(d){
         return '<div class="lab-col-dose-card"><div class="lab-col-dose-top"><span class="lab-col-dose-format">'+esc(d.format)+'</span>' +
           '<span class="lab-col-dose-pct">'+esc(d.pct)+'</span></div><div class="lab-col-dose-bar">'+aboutDoseSegs(d.fill)+'</div></div>';
       }).join("") + '</div></section>';

    h+='<section class="lab-col-about-block lab-col-about-guide is-single"><div class="lab-col-about-guide__text">' +
       '<h2 class="lab-col-about-h2">'+esc(ap.guideHeading)+'</h2><div class="lab-col-about-rte">' +
       ap.guideBody.map(function(p){return '<p>'+esc(p)+'</p>';}).join("") + '</div></div></section>';

    if(ap.education && ap.education.length){
      h+='<section class="lab-col-about-block"><div class="lab-col-about-edugrid">' +
         ap.education.map(function(it){
           var body = it.bodyList ? '<ul>'+it.bodyList.map(function(li){return '<li>'+li+'</li>';}).join("")+'</ul>' : '<p>'+esc(it.body)+'</p>';
           return '<div class="lab-col-edu__item"><h3>'+it.heading+'</h3><div class="lab-col-edu__body">'+body+'</div></div>';
         }).join("") + '</div></section>';
    }
    if(ap.faq && ap.faq.length){
      h+='<section class="lab-col-about-block"><h2 class="lab-col-about-h2">Frequently Asked Questions</h2><div data-faq>' +
         ap.faq.map(function(f,i){
           return '<div class="lab-col-faqitem'+(i===0?' is-open':'')+'"><button type="button" class="lab-col-faqitem__q">' +
             '<span class="q">'+esc(f.q)+'</span><span class="lab-col-faqitem__sign"><span class="plus">+</span><span class="minus">−</span></span></button>' +
             '<div class="lab-col-faqitem__a"><p>'+esc(f.a)+'</p></div></div>';
         }).join("") + '</div></section>';
    }
    return h;
  }
  function renderAbout(s){
    var body=document.querySelector("[data-about-body]");
    if(body) body.innerHTML = buildAboutBody(s);
  }

  var aboutOpen=false;
  function openAbout(){
    renderAbout(src(state.key));
    document.getElementById("le-about-sheet").classList.add("le-about-sheet--open");
    document.querySelector("[data-about-scrim]").classList.add("is-open");
    if (window.LESheetLock) LESheetLock.lock();
    aboutOpen=true;
  }
  function closeAbout(){
    document.getElementById("le-about-sheet").classList.remove("le-about-sheet--open");
    document.querySelector("[data-about-scrim]").classList.remove("is-open");
    if (window.LESheetLock) LESheetLock.unlock();
    aboutOpen=false;
  }

  /* ---------- accordions (compliant / bottles) ---------- */
  function toggleAcc(btn){
    var body=btn.parentElement.querySelector("[data-acc-body]");
    var arrow=btn.querySelector("[data-acc-arrow]");
    var open = body.style.maxHeight && body.style.maxHeight!=="0px";
    if(open){ body.style.maxHeight="0px"; if(arrow) arrow.style.transform=""; }
    else { body.style.maxHeight = body.scrollHeight+40+"px"; if(arrow) arrow.style.transform="rotate(180deg)"; }
  }

  /* ---------- mount + wiring ---------- */
  var state={ key: DATA.defaultSourceKey };
  var block = window.LEPlantSource.mount(
    document.getElementById("plant-source-block"),
    DATA,
    {
      tagEl: document.querySelector("[data-ps-tag]"),
      onChange: function(sel){ state.key=sel.sourceKey; applySource(src(sel.sourceKey)); },
      onAddToCart: function(sel){
        var btn=document.querySelector(".le-ps__cart"); if(!btn) return;
        btn.textContent = "Added "+sel.quantity+" × "+sel.sourceAcronym+" "+sel.sizeMl+"ml";
        setTimeout(function(){ block.render(); }, 1100);
      }
    }
  );

  // Redirect the component's per-card About buttons to the PAGE slide-up
  // (capture phase, before the component's own bubble handler runs).
  document.addEventListener("click", function(e){
    var cardAbout = e.target.closest(".le-ps__about[data-about]");
    if(cardAbout){ e.preventDefault(); e.stopPropagation(); block.select(cardAbout.dataset.about); openAbout(); }
  }, true);

  // Page-level clicks: all About triggers, close, accordions, FAQ toggles
  document.addEventListener("click", function(e){
    if(e.target.closest("[data-open-about]")){ e.preventDefault(); openAbout(); return; }
    if(e.target.closest("[data-close-about]") || e.target.closest("[data-about-scrim]")){ closeAbout(); return; }
    var acc=e.target.closest("[data-acc-btn]"); if(acc){ toggleAcc(acc); return; }
    var faq=e.target.closest(".lab-col-faqitem__q"); if(faq){ faq.parentElement.classList.toggle("is-open"); return; }
  });
  document.addEventListener("keydown", function(e){ if(e.key==="Escape") closeAbout(); });

  applySource(src(DATA.defaultSourceKey));
})();
